
import { Options, Vue } from "vue-class-component";
import BranchCreditService from "../../service/BranchCreditService.js";
import { useStore } from "../../store";
import moment from "moment";
import router from "../../router";

@Options({ title: "Branch Credits" })
export default class BranchCredits extends Vue {
    private store = useStore();
    private service;

    private lists       = [];
    private keyword     = "";
    private totalRecords = 0;
    private limit        = 0;
    private goToFirstLink = 0;
    private checkPagination = true;

    private menuBar = false;
    private historyDialog = false;

    private historyRecords   = [];
    private historyTotal     = 0;
    private historyLimit     = 0;
    private goToSubFirstLink = 0;
    private checkSubPagination = true;

    private selectedBranch: any = null;

    private home  = { icon: "pi pi-home", to: "/" };
    private items = [
        { label: "Initialization", to: "/home/initialization" },
        { label: "Branch Credits", to: "branch-credits" },
    ];

    created() { 
    this.service = new BranchCreditService(); 
    }

    mounted() { 
        this.loadList(0); 
    }

    onPage(event) {
        this.loadList(event.first);
    }

    onSubPage(event) {
        this.loadHistory(event.first);
    }

    loadList(page = 0) {
        this.service.getBranchCreditList(this.keyword, page).then(data => {
            if (!data) return;
            this.lists        = data.records;
            this.totalRecords = data.totalRecords;
            this.limit        = data.limit;
        });
    }

    openMenu(data: any) {
        this.selectedBranch  = data;
        this.menuBar         = true;
        this.historyDialog   = false;
    }

    viewHistory() {
        this.menuBar = false;
        this.goToSubFirstLink = 0;
        this.loadHistory(0);
        this.historyDialog = true;
    }

    loadHistory(page = 0) {
        this.service.getHistory(this.selectedBranch.id, page).then(data => {
            if (data?.status_id == 1) {
                this.historyRecords = data.records;
                this.historyTotal   = data.totalRecords;
                this.historyLimit   = data.limit;
            } else {
                this.historyRecords = [];
            }
        });
    }

    viewTransactions() {
        this.menuBar = false;
        router.replace({
            path: "/process/transactions",
            query: {
                branch_id: this.selectedBranch.id,
                type: 'TSO',
            }
        });
    }

    statusColor(status: string) {
        const map: Record<string, string> = {
            InTransit:   '#3b82f6',
            Completed:   '#00D100',
            Cancelled:   '#FF0000',
            Discrepancy: '#797979',
        };
        return map[status] ?? '#797979';
    }

    formatDate(date: string) {
        return moment(date).format('DD-MM-YYYY');
    }

    formatDateTime(date: string) {
        return moment(date).format('DD-MM-YYYY hh:mm A');
    }

    get currency() {
        return this.store.getters.getCurrency;
    }
}
